import { useMemo, useState } from 'react';
import { APIErrorType } from '../../api';
import { useStudentExams } from '../../hooks/react-query/use-student-exam';
import Error from '../shared/error';
import Loader from '../shared/loader';
import Search, { MIN_SEARCH_LENGTH } from '../shared/search';
import Segment from '../shared/segment';
import StudentExamsHeader from './student-exam-header';
import StudentExamList from './student-exam-list';

function StudentExamsContainer() {
  const { isError, isLoading, data: studentExams, error } = useStudentExams();
  const [search, setSearch] = useState('');

  const filteredStudentExams = useMemo(() => {
    if (!studentExams) return [];
    const trimmed = search.trim();
    if (trimmed.length < MIN_SEARCH_LENGTH) return studentExams;
    const needle = trimmed.toLowerCase();
    return studentExams.filter(item => item.exam?.name?.toLowerCase().includes(needle));
  }, [search, studentExams]);

  if (isError) return <Error error={error as APIErrorType} />;
  if (isLoading) return <Loader />;
  if (!studentExams || studentExams.length === 0)
    return (
      <div>
        <StudentExamsHeader />
        <Segment textAlign='center'>شما تاکنون در هیچ آزمونی شرکت نکرده‌اید.</Segment>
      </div>
    );

  return (
    <div>
      <StudentExamsHeader />
      <Search search={search} setSearch={setSearch} />
      <StudentExamList studentExams={filteredStudentExams} />
    </div>
  );
}

export default StudentExamsContainer;
